import React from "react";

type WidthSelectorDescriptionType = {
  title: string;
  price?: string;
  description: string;
};
export const WidthSelectorDescription = ({
  title,
  price,
  description,
}: WidthSelectorDescriptionType) => {
  return (
    <>
      <div className="gg-flex gg-items-center gg-gap-x-2 sm:gg-justify-between sm:gg-gap-x-0">
        <p className="gg-text-[13px] gg-font-semibold gg-leading-5 gg-text-dark-blue">
          {title}
        </p>
        {price && (
          <p className="gg-whitespace-nowrap gg-text-[11px] gg-font-normal gg-leading-[17.6px] gg-text-secondary-text">
            {price}
          </p>
        )}
      </div>
      <p className="gg-text-xs gg-font-normal gg-leading-5 gg-text-gray-500 sm:gg-text-[13px] lg:gg-text-xs xl:gg-text-[13px]">
        {description}
      </p>
    </>
  );
};
